import React, {Component} from 'react';
import {sumBy} from 'lodash';
import {Modal, Button, Table} from 'semantic-ui-react';
import {convertDateToSpecificFormat} from '../../../../common/util/date';
import './modals.scss';

class ShowInvoicesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  renderItems() {
    const {invoices} = this.props;
    return invoices.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='left'>{element.invoice}</Table.Cell>
          <Table.Cell textAlign='center'>
            {convertDateToSpecificFormat(element.date)}
          </Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTotal() {
    const {invoices} = this.props;

    return (
      <Table.Row>
        <Table.Cell colSpan={2} textAlign='left'>
          <h4>TOTAL</h4>
        </Table.Cell>
        <Table.Cell textAlign='right'>
          <h4>{sumBy(invoices, 'quantity')}</h4>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const {invoices} = this.props;
    const {modalWasOpen} = this.state;

    if (!invoices.length) {
      return null;
    }

    return (
      <Modal
        size='tiny'
        onOpen={() => this.fetchData()}
        className='show-invoices-modal'
        open={modalWasOpen}
        trigger={
          <span className='quantity-total-container'>
            {sumBy(invoices, 'quantity')}
          </span>
        }
      >
        <Modal.Header>Detalle de Facturas</Modal.Header>

        <Modal.Content>
          <Modal.Description>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='left'>Factura</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Fecha</Table.HeaderCell>
                  <Table.HeaderCell textAlign='right'>
                    Cantidad
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.renderItems()}
                {this.renderTotal()}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button positive onClick={this.onCloseModalClick}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default ShowInvoicesModal;
